// getFieldsByPersonType.ts
import {IPersonalityType} from '../../../../../../services/hookService/getUserCooperationAgreementData/types';

interface Field {
  title: string;
  name: string;
  type?: 'text' | 'date' | 'number';
  isRequired: boolean;
}

const individualOnlyFields: Field[] = [
  {title: 'نام مالک فروشگاه', name: 'name', type: 'text', isRequired: true},
  {
    title: 'کد ملی مالک فروشگاه',
    name: 'national_code',
    type: 'number',
    isRequired: true,
  },
  {
    title: 'شماره مجوز فروشگاه',
    name: 'store.license_info.license_number',
    type: 'number',
    isRequired: true,
  },
  {
    title: 'تاریخ صدور مجوز',
    name: 'store.license_info.license_issuance_date',
    type: 'date',
    isRequired: true,
  },
  {title: 'نام فروشگاه', name: 'store.title', type: 'text', isRequired: true},
  {
    title: 'شماره تماس فروشگاه',
    name: 'store.phone_number',
    type: 'number',
    isRequired: true,
  },
  {
    title: 'کد پستی فروشگاه',
    name: 'store.postal_code',
    type: 'number',
    isRequired: true,
  },
  {
    title: 'آدرس فروشگاه',
    name: 'store.address',
    type: 'text',
    isRequired: true,
  },
];

const corporateOnlyFields: Field[] = [
  {
    title: 'نام شخصیت حقوقی',
    name: 'store.license_info.company_name',
    type: 'text',
    isRequired: true,
  },
  {
    title: 'شناسه ملی',
    name: 'store.license_info.national_company_code',
    type: 'number',
    isRequired: true,
  },
  {
    title: 'شماره ثبت',
    name: 'store.license_info.registration_number',
    type: 'number',
    isRequired: true,
  },
  {
    title: 'نمایندگی قانونی اول',
    name: 'store.license_info.first_legal_representative_name',
    type: 'text',
    isRequired: true,
  },
  {
    title: 'کد ملی نماینده اول',
    name: 'store.license_info.first_legal_representative_code',
    type: 'number',
    isRequired: true,
  },
  {
    title: 'موبایل نماینده اول',
    name: 'store.license_info.first_legal_representative_phone_number',
    type: 'number',
    isRequired: true,
  },
  {
    title: 'نمایندگی قانونی دوم',
    name: 'store.license_info.second_legal_representative_name',
    type: 'text',
    isRequired: false,
  },
  {
    title: 'کد ملی نماینده دوم',
    name: 'store.license_info.second_legal_representative_code',
    type: 'number',
    isRequired: false,
  },
  {
    title: 'موبایل نماینده دوم',
    name: 'store.license_info.second_legal_representative_phone_number',
    type: 'number',
    isRequired: false,
  },
  {title: 'نام فروشگاه', name: 'store.title', type: 'text', isRequired: true},
  {
    title: 'شماره مجوز فعالیت',
    name: 'store.license_info.license_number',
    type: 'number',
    isRequired: true,
  },
  {
    title: 'تاریخ صدور مجوز',
    name: 'store.license_info.license_issuance_date',
    type: 'date',
    isRequired: true,
  },
  {
    title: 'شماره تماس فروشگاه',
    name: 'store.phone_number',
    type: 'number',
    isRequired: true,
  },
  {
    title: 'کد پستی فروشگاه',
    name: 'store.postal_code',
    type: 'number',
    isRequired: true,
  },
  {
    title: 'نشانی فروشگاه',
    name: 'store.address',
    type: 'text',
    isRequired: true,
  },
];

const getFieldsByPersonType = (userType: IPersonalityType): Field[] => {
  if (userType === IPersonalityType.Individual) {
    return individualOnlyFields;
  } else {
    return corporateOnlyFields;
  }
};

export default getFieldsByPersonType;
